import { render } from "./CategoryForm.vue?vue&type=template&id=e5468d46&scoped=true&ts=true"
import script from "./CategoryForm.vue?vue&type=script&lang=ts"
export * from "./CategoryForm.vue?vue&type=script&lang=ts"

import "./CategoryForm.vue?vue&type=style&index=0&id=e5468d46&lang=css&scoped=true"

import exportComponent from "/home/issa/hcpet/hcpet-kasse/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e5468d46"]])

export default __exports__